// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".credit_card_wrapper[data-v-f2324e08]{align-items:center;background-color:#fff;border:2px solid #dfdee0;border-radius:5px;display:flex;height:54px}.credit_card_wrapper.is-error[data-v-f2324e08]{border-color:red}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
